export default __webpack_public_path__ + "static/media/logo-us-victoria.8f7f024b.svg";